import usePageTitle from '../../hoook/usePageTitle'

function PrivacyPolicy() {
    usePageTitle('- Privacy Policy')
    return (
        <div className="container">
            <div className="card">
                <div className="card-body">
                    <div
                        name="termly-embed"
                        data-id="8181b809-9699-42a3-801e-29dfb04f0396"
                        data-type="iframe"
                    />
                </div>
            </div>
        </div>
    )
}

export default PrivacyPolicy
